'use client';
const styleKeyVarMap = {
    core: '',
    utility: '',
    accordion: '--swan-accordion',
    alertBox: '--swan-alert-box',
    anchorBar: '--swan-anchor-bar',
    avatar: '--swan-avatar',
    banner: '--swan-banner',
    baseTile: '--swan-base-tile',
    button: '--swan-button',
    carousel: '--swan-carousel',
    emptyState: '--swan-empty-state',
    fieldSet: '--swan-fieldset',
    fileTile: '--swan-file-tile',
    fileDropzone: '--swan-file-dropzone',
    grid: '--swan-grid',
    hidden: '--swan-hidden',
    icon: '--swan-icon',
    listbox: '--swan-listbox',
    modalDialog: '--swan-modal-dialog',
    pagination: '--swan-pagination',
    popover: '--swan-popover',
    priceBar: '--swan-price-bar',
    pricing: '--swan-pricing',
    progressBar: '--swan-progress-bar',
    progressiveImage: '',
    ratingsStars: '--swan-ratings-stars',
    selectionSet: '--swan-selection-set',
    spinner: '--swan-spinner',
    standardTile: '--swan-standard-tile',
    statusMessage: '--swan-status-message',
    stepIndicator: '--swan-step-indicator',
    table: '--swan-table',
    tabs: '--swan-tabs',
    thumbnailsHero: '--swan-thumbnails-hero',
    toggleSwitch: '--swan-toggle-switch',
    visible: '--swan-visible',
    zoomControls: '--swan-zoom-controls'
};

export { styleKeyVarMap };
